import { Hole } from '../models/course';
import { Score } from '../models/player';

export function computeParOffset(scores: Score[], holes: Hole[]): number | null {
    let scoreTotal = 0, parTotal = 0;
    for (const s of scores) {
        const hole = holes.find(h => h.number === s.hole);
        if (hole) {
            scoreTotal += s.score;
            parTotal += hole.par;
        }
    }
    if (parTotal === 0) return null;
    return scoreTotal - parTotal;
}

export function formatOffset(n: number): string {
    if (n === 0) return 'E';
    return n > 0 ? `+${n}` : `−${Math.abs(n)}`;
}
